const MergeStateReducer = (prevState, updatedProperty) => ({
  ...prevState,
  ...updatedProperty,
});

export default MergeStateReducer;
